var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-6 mb-3",class:{'chart-loading': _vm.loading}},[_vm._m(0),_c('Chart',{key:_vm.componentKey,attrs:{"type":"bar","data":_vm.criteriaData,"options":_vm.basicOptions}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"mb-3"},[_c('b',[_vm._v("Tổng Điểm Rủi Ro Theo Mức Độ")])])
}]

export { render, staticRenderFns }